import React, { useRef } from "react";
import { Circle, FeatureGroup, Polygon, Popup, Tooltip } from "react-leaflet";

import { API_CONFIG, MAP_MARKER_TYPES } from "common/config";
import { COLORS } from "common/colors";
import MapMarkers from "./MapMarkers";

const MapPlotting = (props: any) => {
  const {
    details,
    tripDelivery,
    showAreas,
    areas,
    showMarkers,
    showLabels,
    showDelay,
    onClickPolygon,
    delayedVehicles,
    radarMainVehicle,
    nearVehicles,
    childRef,
  } = props;

  const tripGroupRef: any = useRef(null);
  if (childRef) {
    childRef.tripGroupRef = tripGroupRef;
  }

  return (
    <>
      {showAreas &&
        areas.map((polygon, index) => (
          <Polygon
            key={index}
            positions={polygon.vertices}
            color={"red"}
            className="zone"
            onClick={() => onClickPolygon(polygon)}
          >
            <Tooltip
              direction="right"
              className={"zoneLabel"}
              title={polygon.areaName}
              offset={[10, 10]}
              color={"blue"}
            >
              <span style={{ color: "blue" }}>{polygon.areaName}</span>
            </Tooltip>
          </Polygon>
        ))}

      {/* trip deliveries  */}
      <FeatureGroup ref={tripGroupRef}>
        {details &&
          tripDelivery.map((polygon, index) => (
            <Polygon
              key={index}
              positions={polygon.vertices}
              color={"purple"}
              className="zone"
            >
              <Popup>
                <div className="markerPopup">
                  <div>
                    <h4>
                      <span className="popupName">{polygon.areaName}</span>
                    </h4>
                    <p className="popupAddress">{polygon.enteredOn}</p>
                    <p className="popupAddress">{polygon.deliveryComments}</p>

                    {polygon.files.map((v, i) => {
                      return (
                        <img
                          src={`${API_CONFIG.STATIC_URL}${v.path}`}
                          alt="Image Description"
                          style={{ width: "maxContent", height: "100px" }}
                        />
                      );
                    })}
                  </div>
                </div>
              </Popup>
            </Polygon>
          ))}
      </FeatureGroup>

      {radarMainVehicle &&
        nearVehicles.map((range: any, i: number) => {
          return (
            <Circle
              key={"range-" + i}
              radius={range * 1000} // in meters
              fillColor={"red"}
              strokeColor={COLORS.DANGER}
              strokeWidth={2}
              center={[
                radarMainVehicle[0].latitude,
                radarMainVehicle[0].longitude,
              ]}
            />
          );
        })}
      {radarMainVehicle && (
        <MapMarkers
          showMarkers={showMarkers}
          showLabels={showLabels}
          points={radarMainVehicle}
          markerType={MAP_MARKER_TYPES["RADAR"]}
        />
      )}

      {showDelay &&
        delayedVehicles.map((delay, i) => {
          const pointsArray = [delay];
          return delay.delayTime > 86400 ? (
            <MapMarkers
              showMarkers={showMarkers}
              showLabels={showLabels}
              points={pointsArray}
              markerType={MAP_MARKER_TYPES["SEVERE_DELAY"]}
              key={i}
            />
          ) : delay.delayTime > 43200 && delay.delayTime < 86400 ? (
            <MapMarkers
              showMarkers={showMarkers}
              showLabels={showLabels}
              points={pointsArray}
              markerType={MAP_MARKER_TYPES["MODERATE_DELAY"]}
              key={i}
            />
          ) : (
            <MapMarkers
              showMarkers={showMarkers}
              showLabels={showLabels}
              points={pointsArray}
              markerType={MAP_MARKER_TYPES["REGULAR_DELAY"]}
              key={i}
            />
          );
        })}
    </>
  );
};

export default MapPlotting;
